<template>
  <ValidationProvider
    ref="provider"
    :vid="vid"
    :name="$attrs.name"
    :slim="true"
    :rules="rules"
    mode="aggressive"
  >
    <OField
      :variant="errors && errors[$attrs.name] ? 'danger-noBox' : ''"
      :message="errors && errors[$attrs.name] && errors[$attrs.name][0]"
      :root-class="fieldClasses"
      :message-class="messageClass"
      :data-name="$attrs.name"
      role="radio-group"
    >
      <div
        :class="`ucrs-radio__inner ucrs-radio__inner--${layout} ucrs-radio--focus`"
      >
        <ORadio
          v-for="(item, i) in items"
          ref="Radio"
          :key="i"
          v-model="innerValue"
          :name="$attrs.name"
          :native-value="item.value"
          :variant="rootClass"
        >
          {{ item.label }}
        </ORadio>
      </div>
    </OField>
  </ValidationProvider>
</template>

<script>
// Mixins
import RadioAccessibilityMixin from '~/mixins/radio-accessibility'

export default {
  mixins: [RadioAccessibilityMixin],
  inheritAttrs: false,
  props: {
    vid: {
      type: String,
      default: '',
    },

    items: {
      type: Array,
      default: () => [],
    },

    value: {
      type: null,
      default: null,
    },

    layout: {
      type: String,
      default: 'row',
    },

    messageClass: {
      type: String,
      default: '',
    },

    fieldClasses: {
      type: String,
      default: '',
    },

    rules: {
      type: [Object, String],
      default: '',
    },

    errors: {
      type: Object,
      default: () => {
        return null
      },
    },
  },
  data: () => ({
    innerValue: '',
  }),
  computed: {
    rootClass() {
      const rootClass =
        this.errors &&
        this.errors[this.$attrs.name] &&
        this.errors[this.$attrs.name][0]
          ? 'danger'
          : 'visible'
      return rootClass
    },
  },
  watch: {
    innerValue(newVal) {
      this.$emit('input', newVal)
    },
    value(newVal) {
      this.innerValue = newVal
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
  mounted() {
    this.makeRadioElementsAccessible('Radio')
  },
}
</script>

<style lang="postcss">
@import '~/assets/css/components/radio';
</style>
